export default __webpack_public_path__ + "static/media/dashboard-logo.8fa0b15b.svg";